<sm-page-header [breadcrumb]="breadcrumb" [title]="'settings.emailTrace.title'"></sm-page-header>

<div class="card">
  <sm-data-table-builder
    [datas]="data"
    [dataTableObject]="dataTableObject"
    [loading]="loading"
    [totalRecords]="totalRecords"
    (onServerQueryChange)="loadData()"
  ></sm-data-table-builder>
</div>

<sm-dialog #dialog [dialog]="emailTraceDialog"></sm-dialog> 